import { ReactNode } from "react";
import { FieldPath, FieldValues, useFormContext } from "react-hook-form";

type FormControlProps<TFieldValues extends FieldValues> = {
  name: FieldPath<TFieldValues>;
  label: string;
  children: ReactNode;
};

function FormControl<TFieldValues extends FieldValues>({
  name,
  label,
  children,
}: FormControlProps<TFieldValues>) {
  const { getFieldState, formState } = useFormContext<TFieldValues>();
  const { error } = getFieldState(name, formState);
  const errorMessage = typeof error?.message === "string" ? error.message : null;

  return (
    <label className="field">
      <span className="fieldLabel">{label}</span>
      {children}
      {errorMessage ? (
        <span className="errorMessage" role="alert">
          {errorMessage}
        </span>
      ) : null}
    </label>
  );
}

export default FormControl;
